module.exports = __webpack_public_path__ + "img/h5_block03.cd37e20a.webp";